module.exports = __webpack_public_path__ + "static/media/serenity-spa-reflexolgy-and-body-massage.de8d72a2.webp";